// Динамическая подсказка похожих FAQ-статей при наборе subject.
// Дебаунс 400мс, минимум 3 символа, до 5 результатов.
import React, { useEffect, useRef, useState } from "react";
import { searchFaq } from "../../api/tickets";

export default function FaqSearchHint({ query, onPickArticle }) {
  const [items, setItems] = useState([]);
  const abortRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const q = (query || "").trim();
    if (q.length < 3) {
      setItems([]);
      return;
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      if (abortRef.current) abortRef.current.abort();
      const ctrl = new AbortController();
      abortRef.current = ctrl;
      try {
        const data = await searchFaq(q, ctrl.signal);
        setItems(data.faq || []);
      } catch (e) {
        if (e.name !== "AbortError") setItems([]);
      }
    }, 400);
    return () => clearTimeout(timerRef.current);
  }, [query]);

  if (items.length === 0) return null;

  return (
    <div className="sup-faq-hint">
      <div className="sup-faq-hint__title">
        Возможно, эти статьи решат твой вопрос:
      </div>
      <div className="sup-faq-hint__list">
        {items.map((a) => (
          <button
            key={a.id}
            type="button"
            className="sup-faq-hint__item"
            onClick={() => onPickArticle && onPickArticle(a)}
          >
            {a.title}
          </button>
        ))}
      </div>
    </div>
  );
}
